var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "2em",
  height: "2em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.843 12.6 9.775 5H4.033v1.22h.545c.68 0 1.242.421 1.45 1.199l3.162 11.58h2.88l1.412-5.14-.02-.019c-.921 0-1.375-.36-1.619-1.24m11.612 5.179c-.677 0-1.223-.48-1.43-1.22L18.865 5H14.46l3.82 13.999H24v-1.22zM0 17.776V19h5.088v-1.224z"
})));
export default SvgLogo;